import { useStore } from 'effector-react'
import * as React from 'react'
import {
  $clientGroupedPurses,
  clientGroupedPursesListMounted,
  getClientPurses,
} from './model'
import { ClientGroupedPurseRequest, TransformedGatewayData } from './types'

export const useClientPursesList = (clientId: string) => {
  React.useEffect(() => {
    clientGroupedPursesListMounted({
      clientId,
      limit: 10,
      page: 1,
      orderBy: 'updatedAt',
      orderDirection: '-',
      searchText: '',
      searchedColumn: '',
    })
  }, [clientId])

  const onChangeClientPursesList = ({
    clientId,
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    searchedColumn,
  }: ClientGroupedPurseRequest) => {
    clientGroupedPursesListMounted({
      clientId,
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      searchedColumn,
    })
  }

  const clientPurses = useStore($clientGroupedPurses)
  const loading = useStore(getClientPurses.pending)

  return {
    clientPurses,
    loading,
    onChangeClientPursesList,
  }
}
